import moment from 'moment';
import VueI18n from 'vue-i18n';
import { merge } from 'es-toolkit/compat';
import { localize as localizeValidation } from 'vee-validate';

import di from 'di';
import uiMessages from 'js-ui/js/i18n';
import coreMessages from 'js-core/js/i18n';

import 'moment/locale/nl';

import appMessages from 'app/i18n';

export default function() {

    const lang = 'nl';
    const messages = merge(coreMessages, uiMessages, appMessages);

    // I18n
    const i18n = new VueI18n({
        locale: lang,
        messages
    });

    di.set('i18n', i18n);

    // Validator
    localizeValidation(i18n.locale);

    // Moment
    moment.locale(i18n.locale);
}
